import type { AccountDropdownSettings } from "../../../Header";

export type UserDialogLink = {
  href: string;
  label: string;
  nativeBehaviour?: boolean;
};

type GetProfileDropdownLinkProps = {
  label?: string;
  overrideLink?: string;
  hashRoute: string;
  profileLink?: string;
};

export const getProfileDropdownLink = ({
  label,
  overrideLink,
  hashRoute,
  profileLink,
}: GetProfileDropdownLinkProps): UserDialogLink | null => {
  const fallbackLink = profileLink ? `${profileLink}${hashRoute}` : undefined;
  const href = overrideLink || fallbackLink;

  if (!label || !href) {
    return null;
  }

  return {
    href,
    label,
    // Keep native navigation only for the legacy profile hash routes.
    nativeBehaviour: !overrideLink && Boolean(fallbackLink),
  };
};

export const getAccountLinks = (settings: AccountDropdownSettings): UserDialogLink[] => {
  const {
    profileLink,
    accountDashboardLabel,
    accountDashboardLink,
    ordersLabel,
    ordersLink,
    paymentsLabel,
    paymentsLink,
    accountInformationLabel,
    accountInformationLink,
    packCodesLink,
    packCodesLabel,
  } = settings;

  return [
    getProfileDropdownLink({
      label: accountDashboardLabel,
      overrideLink: accountDashboardLink,
      hashRoute: "#/",
      profileLink,
    }),
    getProfileDropdownLink({
      label: ordersLabel,
      overrideLink: ordersLink,
      hashRoute: "#/orders",
      profileLink,
    }),
    getProfileDropdownLink({
      label: paymentsLabel,
      overrideLink: paymentsLink,
      hashRoute: "#/payments",
      profileLink,
    }),
    getProfileDropdownLink({
      label: accountInformationLabel,
      overrideLink: accountInformationLink,
      hashRoute: "#/account",
      profileLink,
    }),
    packCodesLabel && packCodesLink
      ? {
          href: packCodesLink,
          label: packCodesLabel,
        }
      : null,
  ].filter((link): link is UserDialogLink => Boolean(link));
};
